import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Workspace } from '@responsedock/types';

interface WorkspaceState {
  activeWorkspaceId: string | null;
  workspaces: Workspace[];
  setActiveWorkspace: (id: string) => void;
  setWorkspaces: (ws: Workspace[]) => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      activeWorkspaceId: null,
      workspaces: [],
      setActiveWorkspace: (id) => set({ activeWorkspaceId: id }),
      setWorkspaces: (ws) => set({ workspaces: ws }),
    }),
    { name: 'ResponseDock-workspace' },
  ),
);
